import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const path = "/management/roadmap-stage";
export const managementDdoRoadmap = createCrudVuexModule({
  namespaced: true,
  path,
  state: {
    editedTask: undefined,
    tasks: [],
    editedStages: [],
    //
    descriptionPlanning: undefined,
    descriptionApply: undefined,
    descriptionControlAndPrevention: undefined,
    descriptionChangeManagement: undefined,

    //
    isPlanningLoading: false,
    isApplyLoading: false,
    isControlAndPreventionLoading: false,
    isChangeManagementLoading: false,
  },
  getters: {
    editedTask: (state) => state.editedTask,
    tasks: (state) => state.tasks,
    editedStages: (state) => state.editedStages,
    //
    descriptionPlanning: (state) => state.descriptionPlanning,
    descriptionApply: (state) => state.descriptionApply,
    descriptionControlAndPrevention: (state) => state.descriptionControlAndPrevention,
    descriptionChangeManagement: (state) => state.descriptionChangeManagement,

    //
    isPlanningLoading: (state) => state.isPlanningLoading,
    isApplyLoading: (state) => state.isApplyLoading,
    isControlAndPreventionLoading: (state) => state.isControlAndPreventionLoading,
    isChangeManagementLoading: (state) => state.isChangeManagementLoading,
  },
  mutations: {
    reset: (state, value) => {
      state.editedTask = undefined;
      state.tasks = [];
      state.editedStages = [];

      state.descriptionPlanning = undefined;
      state.descriptionApply = undefined;
      state.descriptionControlAndPrevention = undefined;
      state.descriptionChangeManagement = undefined;

      state.isPlanningLoading = false;
      state.isApplyLoading = false;
      state.isControlAndPreventionLoading = false;
      state.isChangeManagementLoading = false;

      state.isUpdating = false;
      state.isLoading = false;
    },

    clearEditedStages: (state, value) => (state.editedStages = []),

    isPlanningLoading: (state, value) => (state.isPlanningLoading = value),
    isApplyLoading: (state, value) => (state.isApplyLoading = value),
    isControlAndPreventionLoading: (state, value) => (state.isControlAndPreventionLoading = value),
    isChangeManagementLoading: (state, value) => (state.isChangeManagementLoading = value),

    descriptionPlanning: (state, value) => {
      state.descriptionPlanning = value;
      if (!state.editedStages.includes("DDO_PLANNING")) {
        state.editedStages.push("DDO_PLANNING");
      }
    },
    descriptionApply: (state, value) => {
      state.descriptionApply = value;
      if (!state.editedStages.includes("DDO_APPLY")) {
        state.editedStages.push("DDO_APPLY");
      }
    },
    descriptionControlAndPrevention: (state, value) => {
      state.descriptionControlAndPrevention = value;
      if (!state.editedStages.includes("DDO_CONTROL_AND_PREVENTION")) {
        state.editedStages.push("DDO_CONTROL_AND_PREVENTION");
      }
    },

    descriptionChangeManagement: (state, value) => {
      state.descriptionChangeManagement = value;

      if (!state.editedStages.includes("DDO_CHANGE_MANAGEMENT")) {
        state.editedStages.push("DDO_CHANGE_MANAGEMENT");
      }
    },

    editedTask: (state, value) => (state.editedTask = value),

    addTaskItemsToStage: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      if (!task._id) {
        task._id = "id" + new Date().getTime(); //id atama
      }

      state.tasks = [...state.tasks, { ...task }];
    },
    updateTaskItemsToStage: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      state.tasks = state.tasks.map((t) => {
        if (t._id == task._id) {
          t = task;
        }

        t.blockedByTasks = t.blockedByTasks?.map((x) => {
          if (x._id == task._id) {
            return task;
          }
          return x;
        });

        return t;
      });
    },

    removeTaskItem: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      state.tasks = state.tasks.filter((t) => t._id != task._id);
    },
  },
  actions: {
    async save({ getters, commit, dispatch }) {
      try {
        commit("isUpdating", true);

        const response = await Promise.all(
          getters.editedStages.map(async (stage) => {
            let payload = {
              tasks: getters.tasks.filter((t) => t.stage == stage),
              roadmapDefinition: "DDO_PRODUCT_ROADMAP",
              definition: stage,
              description: null,
              next: null,
            };

            if (stage == "DDO_PLANNING") {
              payload.description = getters.descriptionPlanning;
              payload.next = ["DDO_APPLY"];
              payload.first = true;
            } else if (stage == "DDO_APPLY") {
              payload.description = getters.descriptionApply;
              payload.next = ["DDO_CONTROL_AND_PREVENTION"];
            } else if (stage == "DDO_CONTROL_AND_PREVENTION") {
              payload.description = getters.descriptionControlAndPrevention;
              payload.next = ["DDO_CHANGE_MANAGEMENT"];
            } else if (stage == "DDO_CHANGE_MANAGEMENT") {
              payload.description = getters.descriptionChangeManagement;
            }

            try {
              commit("isUpdating", true);
              payload = await dispatch("preparePayload", {
                editedEntity: {},
                form: payload,
              });

              const response = await rest.put(`${path}`, { item: payload });
              return response;
            } catch (e) {
              console.error(e);
            }
          })
        );

        return response;
      } finally {
        commit("reset");
      }
    },

    async loadStages({ getters, rootGetters, commit, dispatch }) {
      try {
        commit("reset");

        const language = rootGetters["user/account"].language ?? "tr";
        const stages = ["DDO_PLANNING", "DDO_APPLY", "DDO_CONTROL_AND_PREVENTION", "DDO_CHANGE_MANAGEMENT"];
        const response = await Promise.all(
          stages.map(async (stage) => {
            try {
              if (stage == "DDO_PLANNING") {
                commit("isPlanningLoading", true);
              } else if (stage == "DDO_APPLY") {
                commit("isApplyLoading", true);
              } else if (stage == "DDO_CONTROL_AND_PREVENTION") {
                commit("isControlAndPreventionLoading", true);
              } else if (stage == "DDO_CHANGE_MANAGEMENT") {
                commit("isChangeManagementLoading", true);
              }

              const response = await rest.post(`${path}`, { roadmapDefinition: "DDO_PRODUCT_ROADMAP", definition: stage });
              if (response?.data && typeof response.data === "object") {
                if (response.data.description) {
                  const description = response.data.description[language];

                  if (stage == "DDO_PLANNING") {
                    commit("descriptionPlanning", description);
                  } else if (stage == "DDO_APPLY") {
                    commit("descriptionApply", description);
                  } else if (stage == "DDO_CONTROL_AND_PREVENTION") {
                    commit("descriptionControlAndPrevention", description);
                  } else if (stage == "DDO_CHANGE_MANAGEMENT") {
                    commit("descriptionChangeManagement", description);
                  }
                }

                response.data.tasks.forEach((task) => {
                  task.stage = stage;
                  task.description = task.description;
                  commit("addTaskItemsToStage", { task });
                });
              }

              return response?.data;
            } catch (e) {
              console.error(e);
            } finally {
              if (stage == "DDO_PLANNING") {
                commit("isPlanningLoading", false);
              } else if (stage == "DDO_APPLY") {
                commit("isApplyLoading", false);
              } else if (stage == "DDO_CONTROL_AND_PREVENTION") {
                commit("isControlAndPreventionLoading", false);
              } else if (stage == "DDO_CHANGE_MANAGEMENT") {
                commit("isChangeManagementLoading", false);
              }
            }
          })
        );

        return response;
      } catch (e) {
        console.error(e);
      } finally {
        commit("clearEditedStages");
      }
    },
  },
});
